var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasMessage
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "messenger__container h-center-align",
            class: _vm.messageClass
          },
          [
            _c(
              "div",
              { staticClass: "messenger__title h-display-inline-block" },
              [
                _c("i", { staticClass: "fa", class: _vm.iconClass }),
                _vm._v("\n      " + _vm._s(_vm.message) + "\n    ")
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }